var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6676 0.327393H1.32891C0.594141 0.327393 0 0.886369 0 1.57747V16.4191C0 17.1102 0.594141 17.6726 1.32891 17.6726H16.6676C17.4023 17.6726 18 17.1102 18 16.4225V1.57747C18 0.886369 17.4023 0.327393 16.6676 0.327393ZM5.34023 15.1081H2.66836V6.82846H5.34023V15.1081ZM4.0043 5.70034C3.14648 5.70034 2.45391 5.03296 2.45391 4.20974C2.45391 3.38652 3.14648 2.71914 4.0043 2.71914C4.85859 2.71914 5.55117 3.38652 5.55117 4.20974C5.55117 5.02957 4.85859 5.70034 4.0043 5.70034ZM15.3387 15.1081H12.6703V11.0835C12.6703 10.1247 12.6527 8.8882 11.2816 8.8882C9.89297 8.8882 9.68203 9.93502 9.68203 11.0157V15.1081H7.01719V6.82846H9.57656V7.95996H9.61172C9.9668 7.30952 10.8387 6.62181 12.1359 6.62181C14.8395 6.62181 15.3387 8.336 15.3387 10.5651V15.1081Z",
    fill: "#EDEDED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.079b5f2001b5cd4a0b11f5b6ff279cab.svg";
export { ForwardRef as ReactComponent };